var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntitiesSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "entities",
    d: "M22.9861 6H18V10H21V14H18V16H21V20H18V24H22.9861C23.5458 24 24 23.552 24 23V7C24 6.448 23.5458 6 22.9861 6ZM15 1C15 0.448 14.5458 0 13.9861 0H1.01391C0.454232 0 0 0.448 0 1V23C0 23.552 0.454232 24 1.01391 24H15V1ZM6.5 20H2.5V16H6.5V20ZM6.5 14H2.5V10H6.5V14ZM6.5 8H2.5V4H6.5V8ZM12.5 20H8.5V16H12.5V20ZM12.5 14H8.5V10H12.5V14ZM12.5 8H8.5V4H12.5V8Z",
    fill: "#A4A4FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntitiesSelect);
export default __webpack_public_path__ + "static/media/entities_select.e92d9182eed45f4799f6e1e2d14c2570.svg";
export { ForwardRef as ReactComponent };